/**
 * Stamped onto the return URL by the OAuth landing pages, so the management
 * screen can tell a connection is on its way rather than absent.
 */
export const OAUTH_AUTHORIZED_PARAM = 'authorized'

export const isOAuthAuthorizedReturn = (searchParams: URLSearchParams) =>
  searchParams.get(OAUTH_AUTHORIZED_PARAM) === 'true'
